'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALIGN_SELF_OPTIONS = exports.ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/layout/BoxConstants.js
// module id = 722
// module chunks = 3 4